import { render } from "./EditModuloView.vue?vue&type=template&id=100d0051&scoped=true"
import script from "./EditModuloView.vue?vue&type=script&lang=js"
export * from "./EditModuloView.vue?vue&type=script&lang=js"

import "./EditModuloView.vue?vue&type=style&index=0&id=100d0051&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-100d0051"]])

export default __exports__